export default __webpack_public_path__ + "static/mpos-mobile-point-of-sale-solutions-aa6a9d710f279fc438bea7e103ad22d3.png";